export default function urlPublicS3() {
  return window ? window.urPublicS3 : '';
}
